import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { FinancialSectionsSetFilterService } from './../services/financial-sections-set-filter.service';
import { FinancialSummaryCategoriesSetFilterService } from './../services/financial-items-set-filter.service';
import { Subscription } from 'rxjs';
import { ChartType } from 'chart.js';
import { MultiDataSet, Label, Colors } from 'ng2-charts';
import { ThemeService } from '../theme/theme-service.service';

@Component({
  selector: 'app-financial-summaries-section-items',
  templateUrl: './financial-summaries-section-items.component.html',
  styleUrls: ['./financial-summaries-section-items.component.scss']
})
export class FinancialSummariesSectionItemsComponent implements OnInit, OnDestroy {
  public subscription: Subscription;
  public subscription2: Subscription;
  //filter: string = "assets";
  public title = "";
  public total = 0;
  public chosenValue: string;

  private donutColorsDefault = [
    {
      backgroundColor: [
        '#34274D',
        '#471A66',
        '#5C4A7E',
        '#BCB7C8',
        '#EFEEF8',
        '#FFEED6',
        '#EBD4C5',
        '#98ABB6',
      ]
    }
  ];
  private donutColorsLifeFile = [
    {
      backgroundColor: [
        '#FAB432',
        '#FAB432',
      ]
    }
  ];
  private donutColorsPem = [
    {
      backgroundColor: [
        '#0093D3',
        '#FDEBCB',
      ]
    }
  ];
  private donutColorsPalmers = [
    {
      backgroundColor: [
        '#751A3F',
        '#f2e9ec',
      ]
    }
  ];
  public doughnutChartLabels: Label[] = [];
  public doughnutChartData: MultiDataSet = [
    []
  ];
  public doughnutChartLabelColors: Colors;
  public doughnutChartType: ChartType = 'doughnut';
  public _myCategoriesBalance: {}[];
  public myJointOwnershipCalc;
  public myFilter;
  public myCategory;
  public noItems: boolean;
  public imgEmptySection: string;
  public titleEmptySection: string;
  public emptyId: string;
  public filter: string;
  public defaultTheme: boolean;
  public lifeFileTheme: boolean;
  public pemTheme: boolean;
  public palmersTheme: boolean;
  //@Input() myCategoriesBalance: {}[];
  @Input() set myCategoriesBalance(value: {}[]) {
    this._myCategoriesBalance = value;
    this.filterList(this.myCategory);
    //
  }
  @Input() set jointOwnershipCalc(value) {
    this.myJointOwnershipCalc = value;
  }
  private mySectionList: {}[] = [];
  public showCanvas = false;

  constructor(private financialSectionFilterService: FinancialSectionsSetFilterService,
    private financialNetCategoriesService: FinancialSummaryCategoriesSetFilterService,
    public themeService: ThemeService) { }

  async ngOnInit() {
    this.filterList("assets");
    this.subscription = this.financialNetCategoriesService.getMessage().subscribe(filter => {
      this.myCategory = filter;
      this.filterList(filter);
    });
    switch (this.themeService.theme) {
      case 'default':
        this.defaultTheme = true;
        break;
      case 'life-file':
        this.lifeFileTheme = true;
        break;
      case 'pem':
        this.pemTheme = true;
        break;
      case 'palmers':
        this.palmersTheme = true;
        break;
    }
  }

  async filterList(filter) {
    this.showCanvas = false;
    this.mySectionList = [];
    this.total = 0;
    let mySections: {}[] = this._myCategoriesBalance["sections"];
    switch (filter) {
      case "assets":
        mySections.filter(item => item["assetTotal"] > 0).forEach(section => {
          this.mySectionList.push({
            "sectionName": section["sectionName"],
            "itemCount": section["assetItems"].length, "sectionTotal": section["assetTotal"]
          });
        });
        this.total = this._myCategoriesBalance["assetTotal"];
        if (this.total === 0) {
          this.filter = 'assets';
          this.titleEmptySection = "asset";
          this.emptyId = "myAssets";
        }
        break;
      case "debts":
        mySections.filter(item => item["debtTotal"] > 0).forEach(section => {
          this.mySectionList.push({
            "sectionName": section["sectionName"],
            "itemCount": section["debtItems"].length, "sectionTotal": section["debtTotal"]
          });
        });
        this.total = this._myCategoriesBalance["debtTotal"];
        if (this.total === 0) {
          this.filter = 'debts';
          this.titleEmptySection = "debt";
          this.emptyId = "myDebts";
        }
        break;
      case "income":
        mySections.filter(item => item["incomeTotal"] > 0).forEach(section => {
          this.mySectionList.push({ "sectionName": section["sectionName"], "itemCount": section["incomeItems"].length, "sectionTotal": section["incomeTotal"] });
        });
        this.total = this._myCategoriesBalance["incomeTotal"];
        if (this.total === 0) {
          this.filter = 'income';
          this.titleEmptySection = "income";
          this.emptyId = "myIncome";
        }
        break;
      case "expenses":
        mySections.filter(item => item["expenseTotal"] > 0).forEach(section => {
          this.mySectionList.push({
            "sectionName": section["sectionName"],
            "itemCount": section["expenseItems"].length, "sectionTotal": section["expenseTotal"]
          });
        });
        this.total = this._myCategoriesBalance["expenseTotal"];
        if (this.total === 0) {
          this.filter = 'expenses';
          this.titleEmptySection = "expense";
          this.emptyId = "myExpense";
        }
        break;
    }
    switch (filter) {
      case "assets":
        this.title = "Assets";
        break;
      case "debts":
        this.title = "Debts";
        break;
      case "income":
        this.title = "Annual Income";
        break;
      case "expenses":
        this.title = "Annual Expense";
        break;
    }
    if (this.total > 0) {
      this.mySectionList.sort((a, b) => b["sectionTotal"] - a["sectionTotal"]);
      this.doughnutChartLabels = [];
      this.doughnutChartData = [[]];
      this.mySectionList.forEach(section => {
        this.doughnutChartLabels.push(section["sectionName"] + "(%)");
        let myPercent = Math.round(section["sectionTotal"] * 100 / this.total);
        this.doughnutChartData[0].push(myPercent);
        return '(' + myPercent + '%)'
      });
      this.showCanvas = true;
      this.noItems = false;
    } else if (this.total === 0) {
      this.noItems = true;
    }
  }

  public chartClicked(e: any): void {
    let index = e["active"][0]["_index"];
    this.filterItemsPerSection(this.mySectionList[index]["sectionName"]);
  }

  async filterItemsPerSection(section) {
    await this.filterList(this.myCategory);
    await this.financialSectionFilterService.changeMessage(section);
    this.scroll("section-view-box");
    this.chosenValue = section;
  }

  scroll(id) {
    var elmnt = document.getElementById(id);
    if (elmnt) {
      elmnt.scrollIntoView();
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

}
